import React, { useEffect } from 'react';
import { Page } from '@components/page';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { Header } from './components/header';
import { Body } from './components/body';
import { CardTable } from '@components/table/styled';
import { Col } from 'antd';
import { translate } from '@components/i18n';
import { fetchDeadline } from '@redux/slices/deadline';

export const Deadline: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchDeadline({ current: 1, pageSize: 10 }));
    }, []);

    return (
        <Page
            title={translate('pages.deadline')}
            greyBackground
            onClickGoBack
            menuIcon={<LeftOutlined />}
        >
            <Col span={22} style={{ alignSelf: 'center' }}>
                <h2 style={{ marginTop: '15px' }}>
                    {translate('titlePages.deadline')}
                </h2>
                <CardTable>
                    <Header />
                    <Body />
                </CardTable>
            </Col>
        </Page>
    );
};
